import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import EssenceActionsDropdown from "../EssenceActionsDropdown";
import "../../../../sass/viewer.scss";
import EssenceStateLabel from "../EssenceStateLabel";
export default function TemplatesListGrid(props) {
  const [redirectUrl, redirect] = useState(false);
  let values = [];
  for (let field in props) values.push(field);

  if (redirectUrl) {
    return <Redirect to={redirectUrl} />;
  }

  return (
    <>
      <div className={`col-lg-${props.wide ? "3" : "4"}`}>
        <div className="card card-custom gutter-b h-100">
          <div className="card-body p-5 d-flex justify-content-between flex-column">
            <div>
              <div
                onClick={() =>
                  redirect(`/manual/${props.structure}/${props.id}/`)
                }
                className="documentViewerFrame cursor-pointer"
              >
                <div
                  className="documentViewer box"
                  dangerouslySetInnerHTML={{ __html: props.rendered }}
                ></div>
              </div>

              <div className="py-4 text-center">
                <Link
                  className="text-dark text-hover-primary"
                  to={`/manual/${props.structure}/${props.id}/`}
                >
                  {props.classcode === "template" ? (
                    <span className="font-italic">{props.label}</span>
                  ) : (
                    <span>{props.label}</span>
                  )}
                </Link>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center">
              <EssenceStateLabel
                id={props.id}
                stateCode={props.statetypecode}
                stateLabel={props.statelabel}
                essence="manual"
              />
              <EssenceActionsDropdown
                essence={"manual"}
                key={props.id}
                id={props.id}
                label={props.label}
                onFinish={props.onFinish}
                onDrop={props.onDrop}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
